import { Component, Inject, OnInit } from "@angular/core";
import { NsEmpWebExpData } from "../../../models/emp-web-exp.model";
import { DRAWER_DATA_VAR } from "mis-design-system/drawer";
import { ConfigurationService } from "../../../services/configuration.service";
import { BookingDataService } from "../../../services/booking-data.service";
import { CONSTANTS_ASSETS_EMP_WEB_EXP } from "../../../constants/assets.constants";
import { DrawerRef } from "mis-design-system/drawer";
import { SeatService } from "../../../services/seat.service";
import { CommuteService } from "../../../services/commute.service";

@Component({
  selector: "mis-employee-web-exp-addon-wrapper",
  templateUrl: "./addon-wrapper.component.html",
  styleUrls: ["./addon-wrapper.component.scss"]
})
export class AddonWrapperComponent implements OnInit {
  constructor(
    @Inject(DRAWER_DATA_VAR) configs,
    public commuteSvc: CommuteService,
    public configSvc: ConfigurationService,
    public drawerRef: DrawerRef,
    private seatSvc: SeatService,
    public bookingSvc: BookingDataService
  ) {
    this.addonConfigurations = configs;
  }

  addonConfigurations: NsEmpWebExpData.IAddon;
  ASSETS = CONSTANTS_ASSETS_EMP_WEB_EXP;

  seatSelected: NsEmpWebExpData.ISeatData;

  ngOnInit(): void {
    if (this.addonConfigurations.id === "SEAT") {
      this.seatSvc.temperarySeat.subscribe(res => {
        this.seatSelected = res;
      });
    }
  }

  closeDrawer() {
    this.drawerRef.close();
  }

  selectSeat() {
    if (this.seatSelected) {
      this.seatSvc.changeSeat(this.seatSelected);
      this.closeDrawer();
    }
  }

  selectCommute() {
    if (!this.configSvc.isMobile) return;
    this.commuteSvc.setCommute(this.commuteSvc.temporaryCommuteSelection);
    this.closeDrawer();
  }
}
